export enum DocTypeEnum {
    CPF = 1,
    CNPJ = 2
}
